<template>
  <div class="animated fadeIn">
    <hm-spinner v-if="!ready" />
    <hm-alert />
    <b-row v-for="policy in policies" :key="policy.id" class="pagebreak">
      <b-col v-if="policy.updatedAt">
        <hm-policy :policy="policy" :editable="false" />
        <div ref="policyslot" />
        <hr />
        <div class="text-muted">Approved: {{policy.updatedAt|formatDate('YYYY-MM-DD HH:MM:SS')}} in HIPAAMATE</div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Enumerable from 'linq/linq.js'
import { mapActions } from 'vuex'
import { policyService } from '@/services'

export default {
  name: 'Print.PolicyPrintAll',
  data() {
    return {
      policies: [],
      policyDefaults: {
        id: '',
        data: {}
      },
      ready: false,
      busy: false,
      submitted: false
    }
  },
  methods: {
    ...mapActions({
      alertException: 'alert/exception'
    }),
    onLoad() {
      this.ready = false;

      // get list of all policies
      policyService.getPolicy()
        .then(data => {
          // build a list of the policies to download
          let policies = [];
          for (let i = 0; i < data.length; i++) {
            if (data[i].approved) {
              policies.push(policyService.getPolicy(data[i].id));
            }
          }

          // download all policies
          return Promise.all(policies)
            .then((values) => {
              this.policies = Enumerable.from(values)
                .select(x => {
                  // set any defaults that are missing from data to the default values
                  return { ...this.$options.data.apply(this).policyDefaults, ...x };
                })
                .orderBy(x => { return x.index; })
                .toArray();
            });
        })
        .catch(err => {
          this.alertException({ err, message: 'Error loading policy data.' });
        })
        .finally(() => {
          this.ready = true;
        });
    }
  },
  created() {
    return this.onLoad();
  }
}
</script>

<style scoped>
.pagebreak {
  margin-bottom: 50px;
}

@media print {
    .pagebreak { page-break-after: always; } 
}
</style>
